import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Cell } from '../../base/styled';
import { LineChartWidget } from '../../widgets';

const WeekOverWeekCDN = (props) => {

  const {
    title = '',
    oneDayOnly = false,
    type,
    cdn: {
      error = null,
      data: {
        'wow-cdn-18': fastlyChart = null,
        'wow-cdn-19': level3Chart = null,
        // 'wow-cdn-23': limelightChart = null,
        'wow-cdn-762': akamaiChart = null,
      } = {},
    } = {},
  } = props;

  let keys = [];
  let yAxis = { tickArguments: [null, '%'] };
  let yDomain = [0, 0.15];

  if (type === 'ghosting') {
    keys = [
      ['prevChosting', 'Last Week'],
      ['currGhosting', 'This Week'],
    ];
  } else if (type === 'lates') {
    keys = [
      ['prevLates', 'Last Week'],
      ['currLates', 'This Week'],
    ];
  } else if (type === 'stalls') {
    keys = [
      ['prevStalled', 'Last Week'],
      ['currStalled', 'This Week'],
    ];
  } else if (type === 'bitrate') {
    keys = [
      ['prevBitrate', 'Last Week'],
      ['currBitrate', 'This Week'],
    ];
    yDomain = [2000, 4500];
    yAxis = { tickArguments: [null, 's'] };
  }

  let charts = [fastlyChart, level3Chart, akamaiChart]
    .map(chart => (chart
      ? Object.assign({}, chart, { series: Object.assign({}, chart.series, { keys, yDomain, yAxis }) })
      : null));

  if (oneDayOnly) {
    const now = Date.now();
    const yesterday = now - (24 * 60 * 60 * 1000);
    const xDomain = [yesterday, now];
    charts = charts.map(chart => (chart
      ? Object.assign({}, chart, { series: Object.assign({}, chart.series, { xDomain }) })
      : null));
  }
  return (
    <div className="dashboard">
      <Grid columns={1} rows="50px 1fr 1fr 1fr" alignContent="stretch" height="inherit">
        <h1>{title}</h1>
        {
          charts.map((chart) => (
            <Cell>
              <LineChartWidget input={{ error, data: chart }} />
            </Cell>
          ))
        }
      </Grid>
    </div>
  );
};

WeekOverWeekCDN.defaultProps = null;

WeekOverWeekCDN.propTypes = {
  title: PropTypes.string,
  oneDayOnly: PropTypes.bool,
  type: PropTypes.string,
  cdn: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      'wow-cdn-18': LineChartWidget.dataPropType,
      'wow-cdn-19': LineChartWidget.dataPropType,
      // 'wow-cdn-23': LineChartWidget.dataPropType,
      'wow-cdn-762': LineChartWidget.dataPropType,
    }),
  }),
};

export default WeekOverWeekCDN;
